import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X, ShoppingBag } from "lucide-react";
import { useCart } from "@/lib/CartContext";

const links = [
  { to: "/legacy", label: "Legacy" },
  { to: "/reimagined", label: "Reimagined" },
  { to: "/market-queens", label: "Market Queens" },
  { to: "/impact", label: "Impact" },
  { to: "/blog", label: "Blog" },
  { to: "/fact-or-faytex", label: "Fact or Faytex?" },
  { to: "/b2b", label: "Contract Manufacturing" },
  { to: "/about", label: "About" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { count } = useCart();

  return (
    <header
      data-testid="main-navigation"
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-gray-100"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img
            src="/faytex-logo.webp"
            alt="Faytex"
            className="h-9 md:h-10 w-auto select-none"
            draggable="false"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to.replace("/", "")}`}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors hover:text-faytex-pink ${
                  isActive ? "text-faytex-pink" : "text-faytex-ink"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/cart"
            data-testid="nav-cart-link"
            aria-label={`Cart, ${count} item${count === 1 ? "" : "s"}`}
            className="relative inline-flex items-center justify-center w-10 h-10 rounded-full hover:bg-gray-100"
          >
            <ShoppingBag className="w-5 h-5 text-faytex-ink" />
            {count > 0 && (
              <span data-testid="nav-cart-badge" className="absolute -top-1 -right-1 bg-faytex-pink text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] px-1 flex items-center justify-center">
                {count}
              </span>
            )}
          </Link>
          <Link
            to="/shop"
            data-testid="nav-cta-shop"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-faytex-pink hover:bg-faytex-pinkHover text-white px-5 py-2.5 text-sm font-semibold transition-colors"
          >
            Shop Now
          </Link>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 rounded-md hover:bg-gray-100"
            aria-label="Toggle menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-gray-100 bg-white" data-testid="nav-mobile-panel">
          <div className="px-4 py-4 space-y-2">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="block py-2 text-base font-medium text-faytex-ink hover:text-faytex-pink"
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
